import { ReelAnimationController } from "./ReelAnimationController";
import { ReelDivider } from "./ReelDivider";
import { StageManager } from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import { SanGameConfig } from "../../../SanGameConfig";
import { BaseView } from "@nolimitcity/slot-game/bin/core/base/BaseView";
import { TimelineMax } from "gsap";
import { Helper } from "@nolimitcity/slot-game/bin/core/utils/Helper";

export class ReelAnimationManager extends BaseView{

    private static _instance:ReelAnimationManager;
    private _allReelAreas:ReelAnimationController[] = [];
    private _allDividerAreas:ReelDivider[] = [];

    private _attentionTL:TimelineMax;

    public static get instance():ReelAnimationManager{
        return this._instance;
    }

    public static getReelDivider(id:number):ReelDivider{
        return this.instance._allDividerAreas[id];
    }

    public static getReelArea(id:number):ReelAnimationController{
        return this.instance._allReelAreas[id];
    }

    public get isActive():boolean{
        return this._attentionTL && this._attentionTL.isActive();
    }

    public dividerAttention(value:boolean,duration:number = 0.5):TimelineMax{
        this._attentionTL = Helper.timeLineKiller(this._attentionTL,new TimelineMax({ repeat: value ? -1 : 0}));
        let delay:number = 0;
        for(let k:number = 0; k < this._allDividerAreas.length;k++){
            this._attentionTL.add(this._allDividerAreas[k].flash(duration,!value),delay);
            delay += value ? 0.2 : 0;
        }
        return this._attentionTL;
    }

    constructor(){
        super();
        
        if(!ReelAnimationManager._instance){
            ReelAnimationManager._instance = this;
        } 
        StageManager.getLayer(SanGameConfig.instance.LAYERS.DARK_AREA.name).addChild(this);
    }

    protected initAnimations():void{
        for(let id:number = 0; id < SanGameConfig.instance.REEL_ENGINE_CONFIG.REEL_AMOUNT;id++){
            this._allReelAreas.push(this.addChild( new ReelAnimationController(id)));
        }
    }

    protected onResize(){
        this._allReelAreas.forEach(area => { area.onResize();});
    }
}